import React from 'react';

import type { CollectorCardInfoFragmentDoc, FragmentType } from '@graphql/reactQuery';
import { DataTestId } from '@utils/test';
import type { CollectorsSort } from '..';
import type { SharedCardProps } from './CardInfo';
import { CardInfo } from './CardInfo';
import { CollectorCardSkeleton } from './styles';

export const CollectorCard = ({
  loading,
  collector,
  index,
  sort,
  variant,
  seeAllPage,
}: {
  loading: boolean;
  collector: FragmentType<CollectorCardInfoFragmentDoc>;
  index: number;
  sort: CollectorsSort;
} & SharedCardProps) => {
  return (
    <div className="snap-start" data-testid={DataTestId.COLLECTORS_CARD}>
      {loading ? (
        <CollectorCardSkeleton />
      ) : (
        <CardInfo
          collector={collector}
          index={index}
          variant={variant}
          seeAllPage={seeAllPage}
          sort={sort}
        />
      )}
    </div>
  );
};
